/**
 * A commit's page on its provider (commit ↔ task links, slice 1). Pure.
 * GitHub, Gitea, Codeberg and plain hosts: <repo>/commit/<sha>; GitLab:
 * <repo>/-/commit/<sha>; Bitbucket: <repo>/commits/<sha>. No remote → ''.
 */
import { hostOf, providerOfHost, webUrlOf, withoutUser } from '../../graph/repoRefs';

const SHA = /^[0-9a-f]{7,64}$/i;

export function commitWebUrl(remote, sha, provider = null) {
  if (!remote || !SHA.test(String(sha || ''))) return '';
  const clean = withoutUser(remote);
  const base = webUrlOf(clean);
  if (!base || !/^https?:\/\//.test(base)) return '';
  const kind = provider && provider !== 'local' ? provider : providerOfHost(hostOf(clean));
  if (kind === 'gitlab') return `${base}/-/commit/${sha}`;
  if (kind === 'bitbucket') return `${base}/commits/${sha}`;
  return `${base}/commit/${sha}`;
}
